import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: any[];
  categoryName?: string;
  totalRecords?: number;
}

const initialState: InitialState = {};

const getListEmployeeFeedbackRequestSlice = createSlice({
  name: "getListEmployeeFeedbackRequest",
  initialState,
  reducers: {
    getListEmployeeFeedbackRequestStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getListEmployeeFeedbackRequestSuccess: (
      state,
      action: PayloadAction<{
        data: any[];
        categoryName?: string;
        totalRecords: number;
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...(state.data ?? []), ...action.payload.data];
      state.categoryName = action.payload.categoryName;
      state.totalRecords = action.payload.totalRecords;
    },
    getListEmployeeFeedbackRequestFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = [];
      state.totalRecords = 0;
    },
    resetListEmployeeFeedbackRequest: (state) => initialState,
  },
});

export const {
  getListEmployeeFeedbackRequestStart,
  getListEmployeeFeedbackRequestSuccess,
  getListEmployeeFeedbackRequestFailed,
  resetListEmployeeFeedbackRequest,
} = getListEmployeeFeedbackRequestSlice.actions;

export default getListEmployeeFeedbackRequestSlice.reducer;
